import { render, staticRenderFns } from "./LevelBlock.vue?vue&type=template&id=4d37a6d6&scoped=true"
import script from "./LevelBlock.vue?vue&type=script&lang=js"
export * from "./LevelBlock.vue?vue&type=script&lang=js"
import style0 from "./LevelBlock.vue?vue&type=style&index=0&id=4d37a6d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d37a6d6",
  null
  
)

export default component.exports